import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import RootLoader from '../../../components/root-loader';
import { ApiService } from '../../../services';
import { accessTokenStorage } from '../../../storage/auth';
import { PageRoute } from '../../../types/page.types';
import {
  clearPostAuthRedirect,
  getSafeRedirectFromSearch,
  navigateToInternalRedirect,
  peekPostAuthRedirect,
} from '../../../utils/auth-redirect.util';

const REFRESH_RETRY_DELAYS_MS = [0, 500, 1500];

const GoogleAuthCallback = () => {
  const navigate = useNavigate();
  const didRunRef = useRef(false);

  useEffect(() => {
    if (didRunRef.current) {
      return;
    }
    didRunRef.current = true;

    const completeLogin = async () => {
      accessTokenStorage.getState().delete();

      for (const delayMs of REFRESH_RETRY_DELAYS_MS) {
        if (delayMs > 0) {
          await new Promise((resolve) => setTimeout(resolve, delayMs));
        }

        try {
          await ApiService.refreshTokens();
          const redirectTo =
            peekPostAuthRedirect() ??
            getSafeRedirectFromSearch(window.location.search) ??
            PageRoute.HOME;
          clearPostAuthRedirect();
          navigateToInternalRedirect(navigate, redirectTo);
          return;
        } catch {
          // Retry when the first callback request is still finishing on the server.
        }
      }

      navigate(PageRoute.LOGIN, { replace: true });
    };

    void completeLogin();
  }, [navigate]);

  return <RootLoader />;
};

export default GoogleAuthCallback;
